export const Repositories = {
    //ServerName: 'DisplayName',
    Filesystem: 'IL - Activities',
};



// WEBPACK FOOTER //
// ./src/constants/repositories.js